/* src/app/modules/display/components/not-found/not-found.component.scss */
.sketch-container {
  height: 100vh;
  width: 100vw;
}
/*# sourceMappingURL=not-found.component.css.map */
